module.exports = __webpack_public_path__ + "static/media/check.bcfba235.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/ScheduleCall/components/Objective/assets/check.svg
// module id = 1702
// module chunks = 0